import {
    USER_CREATE_FAILED,
    USER_CREATE_LOAD,
    USER_CREATE_LOADING,
    USER_CREATE_SUCCESS, USER_HIDE_MODAL,
    USER_SHOW_MODAL
} from "../constants/UserCreateConst";
import {BRANCH_HIDE_MODAL, BRANCH_SHOW_MODAL} from "../../../masterdata/redux/constants/BranchConst";


const initState = {
    loading     : false,
    message     : '',
    showMessage : false,
    modal       : false,
    page        : 1,
    total       : 0,
    data        : []
}

const usercreatereducer = (state = initState, action) => {
    switch (action.type) {
        case USER_CREATE_LOADING:
            return {
                ...state,
                loading: true,
            }
        case USER_CREATE_FAILED:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false
            }
        case USER_CREATE_SUCCESS:
            return {
                ...state,
                showMessage: false,
                data:action.data,
                loading: false
            }
        case USER_CREATE_LOAD:
            return {
                ...state,
                data:action.page,
                loading: true,
            }
        case USER_SHOW_MODAL:
            return {
                ...state,
                modal: true,
            }
        case USER_HIDE_MODAL:
            return {
                ...state,
                modal: false,
            }

        default:
            return state;
    }
}

export default usercreatereducer